export default __webpack_public_path__ + "static/media/BLR21.d0f79326.jpg";